import * as z from "zod/v4";

import { StationStep } from "./create-work-order-station";

const WorkOrderStation_ = z.object({
  id: z.string(),
  name: z.string(),
  locationId: z.string().nullable(),
  steps: z.array(StationStep),
  queueCount: z.number().int(),
});
export const WorkOrderStation: z.ZodType<WorkOrderStation> = WorkOrderStation_;
export interface WorkOrderStation extends z.infer<typeof WorkOrderStation_> {}

export const getWorkOrderStations = {
  name: "getWorkOrderStations" as const,
  input: z.object({}),
  output: z.object({ stations: z.array(WorkOrderStation) }),
};
